// Fix for this issue https://github.com/connectrpc/connect-es/issues/878
import { Interceptor } from '@connectrpc/connect';

export const handleInterceptorUserAgent: Interceptor = (next) => (req) => {
  req.header.delete('User-Agent');

  return next(req);
};
